import React from "react";
import { FilterIdsEnum } from "../../../store/reducers/_maps/main/mapFilters/types";
import FilterModal from "../FilterModal";
import FilterButton from "../FilterButton/FilterButton";
import useIsFilterActive from "../../../hooks/useIsFilterActive";
import { useActions } from "../../../hooks/useActions";
import styled from "@emotion/styled";
import { breakpoints } from "../../../constants";
import useMobileScreen from "../../../hooks/useMobileScreen";
import { useTypedSelector } from "../../../hooks/useTypedSelector";

export const StyledFilterWrapper = styled.div<{ fullWidth?: boolean }>`
  position: relative;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};
  @media screen and (max-width: ${breakpoints.small}) {
    padding: 8px 0;
  }
`;

type Props = {
  title: string;
  description?: string;
  filterId: FilterIdsEnum;
  pinText: string | number;
  onClear: any;
  children: React.ReactNode;
  left?: number;
  width?: number;
  fullWidth?: boolean;
  isScroll?: boolean;
};

const FilterButtonWithModal = ({
  title,
  description,
  filterId,
  pinText,
  onClear,
  children,
  left = 0,
  width,
  fullWidth = false,
  isScroll = true,
}: Props) => {
  const isFilterActive = useIsFilterActive(filterId);
  const { toggleFilter } = useActions();
  const isLargeTablet = useMobileScreen(breakpoints.large);
  const isTablet = useMobileScreen(breakpoints.medium);
  const isListViewActive = useTypedSelector(
    (state) => state.mapInterface.isListViewActive
  );
  left = isTablet ? 0 : left;
  const alignRight = isListViewActive && !isLargeTablet;
  return (
    <StyledFilterWrapper fullWidth={fullWidth}>
      <FilterButton filterId={filterId} title={title} pinText={pinText}>
        {title}
      </FilterButton>
      {isFilterActive && (
        <FilterModal
          title={title}
          onClose={() => toggleFilter(filterId)}
          onClear={onClear}
          isScroll={isScroll}
          left={left}
          width={width}
          description={description}
          alignRight={alignRight}
        >
          {children}
        </FilterModal>
      )}
    </StyledFilterWrapper>
  );
};

export default FilterButtonWithModal;
